module.exports = __webpack_public_path__ + "media/images/common/services/say/icon-e044eb53c7c24f1f8cb1ce995415e01d.png";